

import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import type { StoreImpersonationSessionResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

type CreateStoreImpersonationSessionInput = {
  storeId: string;
};

export function useCreateStoreImpersonationSessionMutation() {
  const mutation = useMutation({
    mutationFn: ({ storeId }: CreateStoreImpersonationSessionInput) =>
      apiJsonClient<StoreImpersonationSessionResponse>(
        endpoints.admin.storeImpersonationSession(storeId),
        {
          method: "POST",
        },
      ),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
